import createCrudVuexModule from "@/store/crud";

export const processingAdjective = createCrudVuexModule({
  namespaced: true,
  path: "/library/processing-adjective",
  moduleName: `processing-adjective`,
});

export const workspaceProcessingAdjective = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/processing-adjective",
});

export const managementProcessingAdjective = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/processing-adjective",
});
